
const lastUpdate = '2026-04-30';
export const helpTitle = 'Hotspot Explorer';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Hotspot Explorer shows VIIRS satellite fire detections — thermal anomalies observed by the NOAA-20, NOAA-21, and Suomi-NPP polar-orbiting satellites. Hotspots are the earliest signal that a wildfire may be present and are used alongside lightning detections, ground reports, and aerial observation to guide initial attack decisions.</p>

<h2>Browsing Hotspots</h2>
<ul>
  <li>Records are listed in a grid sorted by detection time (newest first). Click any row to focus its location.</li>
  <li>Detection time is shown in your local timezone.</li>
  <li>Brightness (temperature in Kelvin) and Fire Radiative Power (FRP, in megawatts) indicate the energy of the detected anomaly — higher values suggest more active fire behaviour.</li>
</ul>

<h2>Filtering</h2>
<p>Use the toolbar filters to narrow the visible detections:</p>
<ul>
  <li><strong>Detection Date</strong> — limit to a date range.</li>
  <li><strong>Brightness</strong> / <strong>FRP</strong> — numeric thresholds for filtering by intensity.</li>
  <li><strong>Confidence</strong> — Low, Nominal, or High. The detection algorithm's confidence in the thermal anomaly.</li>
  <li><strong>Satellite</strong> — NOAA-20, NOAA-21, or Suomi-NPP.</li>
  <li><strong>Age</strong> — Hot (under 12 hours), Warm (12–24 hours), or Cold (over 24 hours). Age is computed relative to the current time.</li>
  <li><strong>Latitude</strong> / <strong>Longitude</strong> — bounding-box filtering by coordinate.</li>
</ul>

<h2>Confidence Values</h2>
<ul>
  <li><strong>High</strong> — strong thermal signal, low likelihood of being a false positive (e.g. flare, sun glint).</li>
  <li><strong>Nominal</strong> — typical detection quality.</li>
  <li><strong>Low</strong> — weaker signal; may be a marginal detection.</li>
</ul>

<h2>Exporting</h2>
<p>Use the <strong>Export</strong> button in the toolbar to download the current filtered set as CSV. The export respects your active filters.</p>

<h2>Tips</h2>
<ul>
  <li>For active-fire situational awareness, filter by <strong>Age: Hot</strong> to see only the most recent detections.</li>
  <li>Combine the <strong>Confidence: High</strong> filter with a date range to focus on reliable detections during a specific operational period.</li>
  <li>Hotspots are detections, not confirmed fires — treat them as leads to be investigated, not as fire perimeters.</li>
</ul>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
